var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 2.76953V6.90007C14.75 7.46012 14.75 7.74015 14.859 7.95406C14.9549 8.14222 15.1078 8.2952 15.296 8.39108C15.5099 8.50007 15.7899 8.50007 16.35 8.50007H20.4805M12.75 18.5V12.5M9.75 15.5H15.75M14.75 2.5H9.55C7.86984 2.5 7.02976 2.5 6.38803 2.82698C5.82354 3.1146 5.3646 3.57354 5.07698 4.13803C4.75 4.77976 4.75 5.61984 4.75 7.3V17.7C4.75 19.3802 4.75 20.2202 5.07698 20.862C5.3646 21.4265 5.82354 21.8854 6.38803 22.173C7.02976 22.5 7.86984 22.5 9.55 22.5H15.95C17.6302 22.5 18.4702 22.5 19.112 22.173C19.6765 21.8854 20.1354 21.4265 20.423 20.862C20.75 20.2202 20.75 19.3802 20.75 17.7V8.5L14.75 2.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.6bc0dab97acbdeb03f48dbb0e4881b41.svg";
export { ForwardRef as ReactComponent };